import { render } from "./VideoPlayer.vue?vue&type=template&id=d3c5c3ee"
import script from "./VideoPlayer.vue?vue&type=script&lang=ts"
export * from "./VideoPlayer.vue?vue&type=script&lang=ts"

import "./VideoPlayer.vue?vue&type=style&index=0&id=d3c5c3ee&lang=scss"
script.render = render

export default script